module.exports = __webpack_public_path__ + "static/childprotection_card_img2@2x-8c52e68a7153f631c0ab310479a94e78.jpg";